import {
  pageToPixel,
  pixelToCanvas,
  pixelToCanvasExt,
  pixelToCanvasPure,
  canvasToPixel,
  setToPixelCoordinateSystem,
} from "./coordinate.js";

const coordinate = {
  pageToPixel,
  pixelToCanvas,
  pixelToCanvasExt,
  pixelToCanvasPure,
  canvasToPixel,
  setToPixelCoordinateSystem,
};

export default coordinate;
